module.exports = __webpack_public_path__ + "img/ks_takachi.3008b494.png";